// Generated by tools/actors/build_play_scheduled_actor_shards.mjs.
// Rebuild with `npm run build:scheduled-actors`; do not edit by hand.
export const SCHEDULED_ACTOR_WORLD_SHARD_LOADERS = Object.freeze({
  "arcade": () => import(
    "../play/data/scheduled-actors/arcade.json"
  ),
  "daza": () => import(
    "../play/data/scheduled-actors/daza.json"
  ),
  "dbhb": () => import(
    "../play/data/scheduled-actors/dbhb.json"
  ),
  "dbyo": () => import(
    "../play/data/scheduled-actors/dbyo.json"
  ),
  "dcbn": () => import(
    "../play/data/scheduled-actors/dcbn.json"
  ),
  "dcha": () => import(
    "../play/data/scheduled-actors/dcha.json"
  ),
  "djaz": () => import(
    "../play/data/scheduled-actors/djaz.json"
  ),
  "dkpa": () => import(
    "../play/data/scheduled-actors/dkpa.json"
  ),
  "dkty": () => import(
    "../play/data/scheduled-actors/dkty.json"
  ),
  "dobuita": () => import(
    "../play/data/scheduled-actors/dobuita.json"
  ),
  "dpiz": () => import(
    "../play/data/scheduled-actors/dpiz.json"
  ),
  "drht": () => import(
    "../play/data/scheduled-actors/drht.json"
  ),
  "drme": () => import(
    "../play/data/scheduled-actors/drme.json"
  ),
  "drsa": () => import(
    "../play/data/scheduled-actors/drsa.json"
  ),
  "dsba": () => import(
    "../play/data/scheduled-actors/dsba.json"
  ),
  "dski": () => import(
    "../play/data/scheduled-actors/dski.json"
  ),
  "dsli": () => import(
    "../play/data/scheduled-actors/dsli.json"
  ),
  "dslt": () => import(
    "../play/data/scheduled-actors/dslt.json"
  ),
  "dsus": () => import(
    "../play/data/scheduled-actors/dsus.json"
  ),
  "dtky": () => import(
    "../play/data/scheduled-actors/dtky.json"
  ),
  "dykz": () => import(
    "../play/data/scheduled-actors/dykz.json"
  ),
  "exterior": () => import(
    "../play/data/scheduled-actors/exterior.json"
  ),
  "interior": () => import(
    "../play/data/scheduled-actors/interior.json"
  ),
  "jabe": () => import(
    "../play/data/scheduled-actors/jabe.json"
  ),
  "mfsy": () => import(
    "../play/data/scheduled-actors/mfsy.json"
  ),
  "mksg": () => import(
    "../play/data/scheduled-actors/mksg.json"
  ),
  "mkyu": () => import(
    "../play/data/scheduled-actors/mkyu.json"
  ),
  "ms08": () => import(
    "../play/data/scheduled-actors/ms08.json"
  ),
  "sakuragaoka": () => import(
    "../play/data/scheduled-actors/sakuragaoka.json"
  ),
  "tatq": () => import(
    "../play/data/scheduled-actors/tatq.json"
  ),
  "yamanose": () => import(
    "../play/data/scheduled-actors/yamanose.json"
  ),
});
